

// Autogenerated 2023-05-18 09:36:21.442124
// gen_js_enum.py proto/proto/ugma.proto src/lib/proto/ugma.js

const UGMAEmailInviteRelationship = {
  UGMA_EMAIL_INVITE_RELATIONSHIP_UNDEFINED: { value: 0, id: "UGMA_EMAIL_INVITE_RELATIONSHIP_UNDEFINED" },
  FATHER: { value: 1, id: "FATHER", label: "Father" },
  MOTHER: { value: 2, id: "MOTHER", label: "Mother" },
  BROTHER: { value: 3, id: "BROTHER", label: "Brother" },
  SISTER: { value: 4, id: "SISTER", label: "Sister" },
  HUSBAND: { value: 5, id: "HUSBAND", label: "Husband" },
  WIFE: { value: 6, id: "WIFE", label: "Wife" },
  BROTHER_IN_LAW: { value: 7, id: "BROTHER_IN_LAW", label: "Brother In Law" },
  SISTER_IN_LAW: { value: 8, id: "SISTER_IN_LAW", label: "Sister In Law" },
  FATHER_IN_LAW: { value: 9, id: "FATHER_IN_LAW", label: "Father In Law" },
  MOTHER_IN_LAW: { value: 10, id: "MOTHER_IN_LAW", label: "Mother In Law" },
  FRIEND: { value: 11, id: "FRIEND", label: "Friend" },
  FAMILY_FRIEND: { value: 12, id: "FAMILY_FRIEND", label: "Family Friend" },
  GRAND_FATHER: { value: 13, id: "GRAND_FATHER", label: "Grand Father" },
  GRAND_MOTHER: { value: 14, id: "GRAND_MOTHER", label: "Grand Mother" },
  AUNT: { value: 15, id: "AUNT", label: "Aunt" },
  UNCLE: { value: 16, id: "UNCLE", label: "Uncle" },
  NIECE: { value: 17, id: "NIECE", label: "Niece" },
  NEPHEW: { value: 18, id: "NEPHEW", label: "Nephew" },
  GREAT_GRAND_FATHER: { value: 19, id: "GREAT_GRAND_FATHER", label: "Great Grand Father" },
  GREAT_GRAND_MOTHER: { value: 20, id: "GREAT_GRAND_MOTHER", label: "Great Grand Mother" },
  OTHER: { value: 21, id: "OTHER", label: "Other" },
};
const UGMAInviteState = {
  UGMA_INVITE_STATE_UNDEFINED: { value: 0, id: "UGMA_INVITE_STATE_UNDEFINED" },
  INIT: { value: 1, id: "INIT", label: "Init" },
  SENT: { value: 2, id: "SENT", label: "Sent" },
  OPENED: { value: 3, id: "OPENED", label: "Opened" },
  PAYMENT_INITIATED: { value: 3, id: "PAYMENT_INITIATED", label: "Initiated" },
  PAYMENT_COMPLETED: { value: 4, id: "PAYMENT_COMPLETED", label: "Paid" },
};
export { UGMAEmailInviteRelationship,UGMAInviteState };
